export default "__VITE_ASSET__wVKV9QXu__"